<template>
  <ZubieDialog
    action-button-text="Open URL"
    action-button-type="negative"
    title="Leaving Zubie App"
    :visible="visible"
    @submit="openUrl"
  >
    <div>You are about to open an external website:</div>
    <q-banner class="text-weight-bold bg-light-blue-1"><CopyButton size="sm" :text="url" /> {{ url }}</q-banner>
    <div class="q-mt-md">Please make sure you trust the link before continuing.</div>
  </ZubieDialog>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import CopyButton from 'components/CopyButton.vue';
import ZubieDialog from 'components/ZubieDialog.vue';

const props = defineProps<{ url: string }>();

const visible = ref(true);

function openUrl() {
  window.open(props.url);
  visible.value = false;
}
</script>
